
import { Button } from "@/components/ui/button";
import { Check, X, AlertCircle } from "lucide-react";
import { useState } from "react";
import { EnrolledUser } from "@/types/attendance";

interface BulkActionsProps {
  enrolledUsers: EnrolledUser[];
  classId: string | undefined;
  selectedDate: string;
  onBulkAction: (action: 'present' | 'absent') => void;
  isUpdating: boolean;
}

export const BulkActions = ({ enrolledUsers, classId, selectedDate, onBulkAction, isUpdating }: BulkActionsProps) => {
  const [showConfirmation, setShowConfirmation] = useState<'present' | 'absent' | null>(null);

  if (!enrolledUsers || enrolledUsers.length === 0) {
    return <div className="text-center text-white/60 py-2 mb-4">No hay alumnos para mostrar</div>;
  }

  const handleConfirmAction = (action: 'present' | 'absent') => {
    onBulkAction(action);
    setShowConfirmation(null);
  };

  return (
    <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2 mb-4">
      {showConfirmation ? (
        <div className="flex items-center space-x-2 p-2 rounded-md bg-[#253B3D] border border-[#00C1D6]/30 text-white">
          <AlertCircle className="h-5 w-5 text-[#00C1D6]" />
          <span className="text-sm">
            ¿Confirmar marcar a todos como {showConfirmation === 'present' ? 'presentes' : 'ausentes'}?
          </span>
          <Button
            size="sm"
            variant="default"
            className="bg-[#00C1D6] hover:bg-[#00C1D6]/80 text-white"
            onClick={() => handleConfirmAction(showConfirmation)}
            disabled={isUpdating}
          >
            <Check className="h-4 w-4 mr-1" />
            Confirmar
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="text-white hover:bg-[#253B3D] hover:text-white"
            onClick={() => setShowConfirmation(null)}
            disabled={isUpdating}
          >
            Cancelar
          </Button>
        </div>
      ) : (
        <>
          <Button
            variant="outline"
            className="border-[#00C1D6]/30 bg-[#253B3D] text-white hover:bg-[#253B3D] hover:text-white hover:border-[#00C1D6]"
            onClick={() => setShowConfirmation('present')}
            disabled={isUpdating}
          >
            <Check className="h-4 w-4 mr-1" />
            Marcar todos presentes
          </Button>
          <Button
            variant="outline"
            className="border-[#00C1D6]/30 text-white bg-[#253B3D] hover:bg-[#253B3D] hover:text-white hover:border-[#00C1D6]"
            onClick={() => setShowConfirmation('absent')}
            disabled={isUpdating}
          >
            <X className="h-4 w-4 mr-1" />
            Marcar todos ausentes
          </Button>
        </>
      )}
    </div>
  );
};
